<template>
  <pdf-viewer :pdfUrl="samplePdf" />
</template>

<script>
import PdfViewer from "./PdfViewer.vue";

export default {
  components: { PdfViewer },
  data() {
    return {
      samplePdf: "Help.pdf",
    };
  },
  name: "Help",
};
</script>

<style></style>
